import IconButton from '@mui/material/IconButton';
import Tooltip, { TooltipProps, tooltipClasses } from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { styled, useTheme } from '@mui/material/styles';
import { ComponentPropsWithoutRef } from 'react';

const InfoTooltip = styled(
  ({ className, arrow = true, ...props }: TooltipProps) => {
    return (
      <Tooltip
        {...props}
        arrow={arrow}
        classes={{
          popper: className,
        }}
      />
    );
  },
)(({ theme }) => {
  return {
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.primary.main,
      padding: '4px 8px',
    },
    [`& .${tooltipClasses.arrow}`]: {
      color: theme.palette.primary.main,
    },
  };
});

const InfoTooltipButton = styled(IconButton)(() => ({
  padding: '0',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  '&:hover': {
    backgroundColor: 'transparent',
  },
}));

type InfoTooltipTextProps = ComponentPropsWithoutRef<typeof Typography>;
function InfoTooltipText({ sx, children, ...props }: InfoTooltipTextProps) {
  const theme = useTheme();

  return (
    <Typography
      component={'p'}
      sx={{
        color: theme.palette.primary.contrastText,
        fontSize: '10px',
        lineHeight: '14px',
        fontStyle: 'normal',
        fontWeight: '400',
        ...sx,
      }}
      {...props}
    >
      {children}
    </Typography>
  );
}

export { InfoTooltip, InfoTooltipText, InfoTooltipButton };
